// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"80c0ab95c861f22ecc26","339":"ee5716355123d2025211"}[chunkId] + ".js";
};